import { createStore, applyMiddleware} from 'redux';
import reducers from './Reducers';
import thunk from 'redux-thunk';

const store = createStore(reducers, applyMiddleware(thunk));

export default store;


// WEBPACK FOOTER //
// ./src/store.js